(() => {
    const scriptEl =
        document.currentScript ||
        document.querySelector('script[data-wd-sales-rep="true"]');

    if (!scriptEl) {
        return;
    }

    // get the rep value from the url
    const repParam = new URLSearchParams(window.location.search).get('rep');
    const repValue = repParam && repParam.trim();

    // store the rep value in the session storage
    if (repValue)
        sessionStorage.setItem('wdSalesRepresentative', repValue);

    const storedRep = sessionStorage.getItem('wdSalesRepresentative');
    const isVisible = scriptEl.dataset.wdSalesRepVisible === 'true';

    // sync the rep value to the cart attribute
    if (storedRep)
        syncCartAttribute(storedRep);

    // if the rep value is not stored or the label is not visible, return
    if (!storedRep || !isVisible) {
        return;
    }

    const position = scriptEl.dataset.wdSalesRepPosition || 'fixed';
    const direction = scriptEl.dataset.wdSalesRepDirection || 'right';

    const label = document.createElement('div');
    label.className = [
        'wd-sales-representative',
        `wd-sales-representative--${position}`,
        `wd-sales-representative--${direction}`
    ].join(' ');
    label.textContent = `מזהה נציג ${storedRep}`;

    if (position === 'static')
        scriptEl.insertAdjacentElement('afterend', label);
    else
        document.body.appendChild(label);

    // sync the rep value to the cart attribute
    async function syncCartAttribute(id) {
        let repId = id;
        if (!repId)
            repId = sessionStorage.getItem('wdSalesRepresentative');
        if (!repId)
            return;

        console.log('syncCartAttribute', repId);

        const attributeKey = 'sales_rep';
        const root = window.Shopify?.routes?.root || '/';
        try {
            // get the cart data
            const cart = await fetch(`${root}cart.js`, { credentials: 'same-origin' }).then(
                (res) => res.json()
            );
            const currentValue = cart?.attributes?.[attributeKey];
            // if the rep value is already set, return
            if (currentValue === repId) {
                return;
            }
            // update the cart attribute
            await fetch(`${root}cart/update.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ attributes: { [attributeKey]: repId } })
            });
        } catch (error) {
        }
    };
})();
